import { render } from "./ItemCategory.vue?vue&type=template&id=389f71ba"
import script from "./ItemCategory.vue?vue&type=script&lang=js"
export * from "./ItemCategory.vue?vue&type=script&lang=js"

import "./ItemCategory.vue?vue&type=style&index=0&id=389f71ba&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__